import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getPatientById, subscribeToPatient } from '../services/cloudflareService';

export const usePatientSync = (patientId: string | undefined | null) => {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['patient', patientId],
        queryFn: () => patientId ? getPatientById(patientId) : null,
        enabled: !!patientId,
    });

    useEffect(() => {
        if (!patientId) return;

        const unsubscribe = subscribeToPatient(patientId, (updatedPatient) => {
            if (updatedPatient) {
                // Instantly update the cache, triggering a flicker-free re-render React-Query style
                queryClient.setQueryData(['patient', patientId], updatedPatient);
            }
        });

        const handleOptimisticUpdate = (event: Event) => {
            const customEvent = event as CustomEvent;
            const updatedPatient = customEvent.detail;
            if (updatedPatient && updatedPatient.id === patientId) {
                queryClient.setQueryData(['patient', patientId], updatedPatient);
            }
        };

        window.addEventListener('patient-updated-optimistically', handleOptimisticUpdate);

        return () => {
            unsubscribe();
            window.removeEventListener('patient-updated-optimistically', handleOptimisticUpdate);
        };
    }, [patientId, queryClient]);

    return query;
};
